import { lazy } from 'react';

const sraTemplateTypes = [
  {
    label: 'Sidebar Navigation',
    value: 'sidebarNavigation',
  },
  {
    label: 'Top Navigation',
    value: 'topbarNavigation',
  },
  {
    label: 'Default',
    value: 'default',
  },
];

export default sraTemplateTypes;

export const KA_SMART_CHAT_PANEL_TEMPLATE = 'sidePanelThree';
export const KA_SMART_CHAT_INLINE_TEMPLATE = 'inlineFive';
export const KA_SMART_CHAT_AURORA_TEMPLATE = 'smartChatAurora';
// Smart Chat Aurora · Voice: the template exactly when campaignData.voiceConfig.isActive is true.
export const KA_SMART_CHAT_VOICE_TEMPLATE = 'smartChatVoice';

export const getKaSmartChatTemplateForPlacementType = placementType =>
  placementType === 'sidePanel' ? KA_SMART_CHAT_PANEL_TEMPLATE : KA_SMART_CHAT_INLINE_TEMPLATE;

export const getDesktopPlacementType = placements => {
  const desktopPlacement = (placements || []).find(
    placement => (placement.deviceType || 'desktop') === 'desktop'
  );
  return desktopPlacement?.placementData?.type;
};

export const kaTemplateTypes = [
  {
    label: 'Smart Chat Panel',
    value: 'sidePanelThree',
    type: ['sidePanel'],
    key: 'sidePanelThree',
  },
  {
    label: 'Smart Chat Inline',
    value: 'inlineFive',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
    key: 'inlineFive',
  },
  {
    label: 'Smart Chat Aurora',
    value: 'smartChatAurora',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern', 'sidePanel'],
    key: 'smartChatAurora',
  },
  {
    label: 'Smart Chat Aurora · Voice',
    value: 'smartChatVoice',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern', 'sidePanel'],
    key: 'smartChatVoice',
  },
  {
    label: 'Smart Chat Nova',
    value: 'sidePanelTwo',
    type: ['sidePanel'],
    key: 'sidePanelTwo',
  },
  // {
  //   label: 'Basic',
  //   value: 'two',
  //   type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
  //   key: 'two',
  // },
  // {
  //   label: 'Centred',
  //   value: 'three',
  //   type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern', 'sidePanel'],
  //   key: 'three',
  // },
  // {
  //   label: 'Default',
  //   value: 'default',
  //   type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
  //   key: 'default',
  // },
  // {
  //   label: 'Inline FAQ',
  //   value: 'inlineFAQ',
  //   type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
  //   key: 'inlineFAQ',
  // },
  {
    label: 'Smart Chat Canvas',
    value: 'singlePageOne',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
    key: 'singlePageOne',
  },
  // {
  //   label: 'Inline Two', // TODO: Remove this after discuss with the team
  //   value: 'inlineTwo',
  //   type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern', 'sidePanel'],
  //   key: 'inlineTwo',
  // },
  {
    label: 'Inline Three',
    value: 'inlineThree',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
    key: 'inlineThree',
  },
  {
    label: 'FAQ Stack & Search',
    value: 'seven',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
    key: 'seven',
  },
  {
    label: 'FAQ Accordion',
    value: 'eight',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
    key: 'eight',
  },
];

export const personalizationToolTemplateTypes = [
  {
    label: 'Smart Chat Panel',
    value: 'sidePanelThree',
    type: ['sidePanel'],
    key: 'sidePanelThree',
  },
  {
    label: 'Smart Chat Inline',
    value: 'inlineFive',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern'],
    key: 'inlineFive',
  },
  {
    label: 'Smart Chat Aurora',
    value: 'smartChatAurora',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern', 'sidePanel'],
    key: 'smartChatAurora',
  },
  {
    label: 'Smart Chat Aurora · Voice',
    value: 'smartChatVoice',
    type: ['inline', 'paragraph', 'stickyBox', 'htmlElement', 'stringPattern', 'sidePanel'],
    key: 'smartChatVoice',
  },
];

export const defaultTemplateTypes = [
  {
    label: 'Default',
    value: 'default',
  },
];

export const engagementGenerationByAITemplateTypesPoll = [
  {
    label: 'New Poll',
    value: 'pollOne',
  },
  {
    label: 'Default',
    value: 'default',
  },
];

export const engagementGenerationByAITemplateTypesSliderPoll = [
  {
    label: 'New Slider Poll',
    value: 'sliderPollOne',
  },
  {
    label: 'Default',
    value: 'default',
  },
];
